<template>
  <div class="container mt-1">
    <b-row>
      <b-col cols="8" class="container">
        <ComplaintGroupDetailList
          :routeName="routeName"
          :listRouteName="listRouteName"
          :complaintGroupId="id"
          :complaintGroupIssue="complaintGroup.complaintDetail" 
          :complaintGroupCode="complaintGroup.complaintGroupCode"
          :complaintGroupDetails="complaintGroup.complaintGroupDetails"
          :complaintGroupIsProcessAvailable="complaintGroup.isProcessAvailable"
          :modeGrp="modeGrp"
          @handleOnComplaintHeaderClick="onComplaintHeaderClick"
        >
        </ComplaintGroupDetailList>
      </b-col>

      <!-- หมายเหตุ copyComponentName ของ RightTab ComplaintGroup => 
      ScreeningGroupManage / OfficerGroupManage /  LawOfficerGroupManage -->
      <RightTab
        :complaintId="this.$route.query.id"
        :redirectComponentName="'RequestConfirm'"
        :backComponentName="listRouteName"
        :copyComponentName="routeName" 
        :IsUse_Tab3="true"
        :isComplaintGrp="true"
        :complaintGroupIsProcessAvailable="complaintGroup.isProcessAvailable"
        ref="right-tab"
      />
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";

import ComplaintGroupDetailList from "./components/ComplaintGroupDetailList.vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import * as storeComplaintGroup from "@/store/api/complaint/complaintGroup";

import RightTab from "../../components/RightTabAction.vue";

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BListGroup,
    BListGroupItem,
    ComplaintGroupDetailList,

    RightTab,
  },
  props: {
    routeName: String,
    listRouteName: String,
    id: null,
    modeGrp: String,
  },
  data() {
    return {
      complaintGroup: {},
    };
  },
  mounted() {
    //console.log("on mounted props.id =", this.id);
    this.getComplaintGroupById(this.id);
  },
  methods: {
    getComplaintGroupById(id) {
      const _this = this;

      storeComplaintGroup.getComplaintById(id).then((response) => {
        if (response.data.success) {
          // need to set isLoad for display value
          let group = response.data.data;
          group.complaintGroupDetails = group.complaintGroupDetails.map(
            (elem, index) => {
              if (index === 0) {
                elem.isLoad = true;
              } else {
                elem.isLoad = false;
              }
              return elem;
            }
          );

          _this.complaintGroup = group;
          console.log("_this.complaintGroup", _this.complaintGroup);
        }
      });
    },
    onComplaintHeaderClick(complaintId) {
      //console.log("handle onComplaintHeaderClick", complaintId);

      // set isLoad = true
      this.complaintGroup.complaintGroupDetails.forEach((item) => {
        if (item.complaintId === complaintId) {
          //console.log("set isLoad = true", complaintId);
          item.isLoad = true;
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
